import { Component, OnInit } from '@angular/core';
import { CartService } from './cart.service';
import { SharedService } from '../shared.service';
import { SiteConfig } from 'app/interfaces/SiteConfig';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, first, pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  public siteConfig: SiteConfig = this.sharedService.getSiteConfig();
  public showCartPage: Boolean = this.siteConfig.showCartPage;
  public env: String = this.sharedService.getEnvironment();
  public isValidCart: Boolean = false;

  constructor(
    private cartService: CartService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  ngOnInit() {
    this.cartService.cartUpdated.subscribe((calculatedProduct) => {
      this.isValidCart = calculatedProduct.ticketAmount > 0 ? true : false;
    });

    /**
     * Only trigger remove_from_cart event when coming back from address form
     * or summary step.
     */
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise(),
        first()
      )
      .subscribe((events: RoutesRecognized[]) => {
        if (
          (events[0].urlAfterRedirects === '/bestellen/address' ||
            events[0].urlAfterRedirects === '/bestellen/bestaetigung') &&
          this.cartService.getProducts() &&
          this.cartService.getProducts().length > 0 &&
          events[1].urlAfterRedirects.includes('/cart')
        ) {
          this.sharedService.pushCustomToDataLayer({
            event: 'remove_from_cart',
            ecommerce: {
              currency: 'EUR',
              value: this.cartService.getTotalPriceWithoutDiscount(),
              items: this.cartService.getProductsForGTMTracking()
            }
          });
        }
      });
  }
}
